import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { getLeaderboard, LEADERBOARD_CATEGORIES } from '../firebase/leaderboardService';
import SeoHead from '../components/SeoHead';
import { LetterHiveBrandIcon, WordRungsBrandIcon } from '../components/icons/BrandGameIcons';
import './LeaderboardPage.css';

function LeaderboardTabIcon({ cat, active }) {
  const tone = active ? 'onAccent' : 'brand';
  if (cat.iconId === 'letter-hive') {
    return <LetterHiveBrandIcon title={cat.name} tone={tone} />;
  }
  if (cat.iconId === 'word-rungs') {
    return <WordRungsBrandIcon title={cat.name} tone={tone} />;
  }
  return <>{cat.icon}</>;
}

export default function LeaderboardPage() {
  const { user } = useAuth();
  const [category, setCategory] = useState(LEADERBOARD_CATEGORIES[0].id);
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    getLeaderboard(category, 20)
      .then(setEntries)
      .catch((err) => {
        setError(err?.message || 'Failed to load leaderboard');
        setEntries([]);
      })
      .finally(() => setLoading(false));
  }, [category]);

  const currentCat = LEADERBOARD_CATEGORIES.find((c) => c.id === category);

  return (
    <main className="leaderboard">
      <SeoHead
        title="Leaderboard"
        description="Top scores and streaks for Letter Quest: Word Master, Letter Hive, Word Rungs, Word Square, Hidden Words, and more."
        path="/leaderboard"
      />
      <section className="leaderboard__hero">
        <h1 className="leaderboard__title">Leaderboard</h1>
        <p className="leaderboard__tagline">Top scores and streaks</p>
      </section>

      <div className="leaderboard__tabs">
        {LEADERBOARD_CATEGORIES.map((cat) => (
          <button
            key={cat.id}
            type="button"
            className={`leaderboard__tab ${category === cat.id ? 'active' : ''}`}
            onClick={() => setCategory(cat.id)}
          >
            <span className="leaderboard__tab-icon">
              <LeaderboardTabIcon cat={cat} active={category === cat.id} />
            </span>
            {cat.name}
          </button>
        ))}
      </div>

      <section className="leaderboard__content">
        {loading ? (
          <p className="leaderboard__loading">Loading...</p>
        ) : error ? (
          <p className="leaderboard__error">{error}</p>
        ) : entries.length === 0 ? (
          <p className="leaderboard__empty">
            No entries yet. Be the first to claim the top spot!
          </p>
        ) : (
          <div className="leaderboard__table-wrapper">
            <table className="leaderboard__table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Player</th>
                  <th>{currentCat?.unit ?? 'Score'}</th>
                </tr>
              </thead>
              <tbody>
                {entries.map((entry) => (
                  <tr
                    key={entry.uid}
                    className={user?.uid === entry.uid ? 'leaderboard__row--me' : ''}
                  >
                    <td className="leaderboard__rank">{entry.rank}</td>
                    <td className="leaderboard__name">{entry.displayName || 'Anonymous'}</td>
                    <td className="leaderboard__value">{entry.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </main>
  );
}
